import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChatService, LIVECROUSELOPTION, SportService } from '@app/core';
// import { Socket } from 'ngx-socket-io';

@Component({
  selector: 'app-live-scores',
  templateUrl: './live-scores.component.html',
  styleUrls: ['./live-scores.component.scss'],
})
export class LiveScoresComponent implements OnInit {
  liveOption = LIVECROUSELOPTION;
  liveScores: any[] = [];
  constructor(
    public _chat: ChatService,
    public _sport: SportService,
    public _activated: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._chat._socket.removeListener('live-scores');
    this._chat._socket.on('live-scores',(data:any) =>{
      this.liveScores = data.results;
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this._chat._socket.removeListener('live-scores');
  }
}
